import { userRegisterContract } from "@common/contracts/user-register.contract";
import { useMutation } from "@tanstack/react-query";
import { UserSignupPurpose } from "@common/types/user";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const userRegisterApiClient = getBackendAPIClient(userRegisterContract);

export async function validateInviteCode(code: string) {
    const response = await userRegisterApiClient.validateInviteCode({
        body: {
            inviteCode: code,
        },
    });

    return response.body;
}

interface RegisterMutationParams {
    email: string;
    inviteCode?: string;
    signupPurpose?: UserSignupPurpose;
}

export function useRegisterMutation() {
    return useMutation({
        mutationFn: async ({
            email,
            inviteCode,
            signupPurpose,
        }: RegisterMutationParams) =>
            await userRegisterApiClient.register({
                body: {
                    email,
                    inviteCode,
                    signupPurpose,
                },
            }),
    });
}
